import { campaignConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  list: null,
  count: 0,
  init: false,
  updating: false
}

export default function campaign(state = initialState, action) {
  switch (action.type) {
    case campaignConstants.CAMPAIGN_LOAD:
      return {
        ...state,
        loading: true,
        list: null,
        init: true
      }
    case campaignConstants.CAMPAIGN_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list.sort((a, b) => a.name.localeCompare(b.name)),
        count: action.payload.count
      }
    case campaignConstants.CAMPAIGN_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case campaignConstants.CAMPAIGN_SAVE:
    case campaignConstants.CAMPAIGN_DELETE:
    case campaignConstants.CAMPAIGN_BACK_TO_DRAFT:
      return {
        ...state,
        updating: true
      }
    case campaignConstants.CAMPAIGN_SAVE_SUCCESS:
    case campaignConstants.CAMPAIGN_BACK_TO_DRAFT_SUCCESS:
      const list = (
        state.list.find((x) => x._id === action.payload._id)
          ? state.list.map((x) => {
              return x._id === action.payload._id ? action.payload : x
            })
          : [...state.list, action.payload]
      ).sort((a, b) => a.name.localeCompare(b.name))
      return {
        ...state,
        updating: false,
        list,
        count: list.count
      }
    case campaignConstants.CAMPAIGN_SAVE_FAILURE:
    case campaignConstants.CAMPAIGN_DELETE_FAILURE:
    case campaignConstants.CAMPAIGN_BACK_TO_DRAFT_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      }
    case campaignConstants.CAMPAIGN_DELETE_SUCCESS:
      return {
        ...state,
        updating: false,
        list: state.list.filter((x) => x._id !== action.payload),
        count: state.count - 1
      }
    case campaignConstants.CAMPAIGN_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
